<template>
    <div class="card-deal-params-block">
        <el-row v-if="canViewField('measurement_date') && isValueVisible(measurement_date, 'measurement_date')">
            <el-col :span="10">
                <span class="gray">
                    Дата замера
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField('measurement_date')">
                    <el-date-picker
                        v-model="measurement_date"
                        type="date"
                        placeholder="дд.мм.гггг"
                        clearable
                        format="dd.MM.yyyy"
                        value-format="dd.MM.yyyy"
                        :picker-options="pickerOptions"
                        size="mini"
                        class="w100"
                    />
                    <div class="field-error" v-if="errors.measurement_date" v-text="errors.measurement_date[0]"></div>
                </template>
                <template v-else>
                    {{ measurement_date }}
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'measurement_time') && isValueVisible( measurement_time, 'measurement_time')">
            <el-col :span="10">
                <span class="gray">
                    Время замера
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'measurement_time')">
                    <el-select
                        v-model="measurement_time"
                        placement="bottom"
                        popper-class="popper-dropdown"
                        autocomplete
                        clearable
                        placeholder=""
                        size="mini"
                    >
                        <el-option v-for="item in measurementTimeList" :key="item" :label="item" :value="item" />
                    </el-select>
                    <div class="field-error" v-if="errors.measurement_time" v-text="errors.measurement_time[0]"></div>
                </template>
                <template v-else>
                    {{ measurement_time }}
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'measurer_user_id') && isValueVisible(measurer_user_id, 'measurer_user_id')">
            <el-col :span="10">
                <span class="gray">
                    Замерщик
                </span>
            </el-col>
            <template v-if="!isCurrentEmployerManager && editMode && canEditField( 'measurer_user_id')">
                <el-col :span="14">
                    <el-select
                        v-model="measurer_user_id"
                        placement="bottom"
                        popper-class="popper-dropdown"
                        autocomplete
                        filterable
                        clearable
                        placeholder="Замерщик"
                        size="mini"
                        v-loading="isMeasurerListLoading"
                    >
                        <el-option
                            v-for="measurer in measurerList"
                            :key="measurer.id"
                            :label="`${measurer.full_name}${measurer.disabled ? ' (' + measurer.disabledComment + ')' : ''}`"
                            :value="measurer.id"
                            :class="isFiredEmployerClass(measurer.date_fired)"
                        />
                    </el-select>
                    <div class="field-error" v-if="errors.measurer_user_id" v-text="errors.measurer_user_id[0]"></div>
                </el-col>
            </template>
            <template v-else>
                <span @click="goCard(measurer_user_id)" class="orange pointer">
                    {{ measurerUserName }}
                </span>
            </template>
        </el-row>
        <el-row v-if="canViewField( 'difficult_metering') && isValueVisible(difficult_metering, 'difficult_metering')">
            <el-col :span="10">
                <span class="gray">
                    Сложный замер
                </span>
            </el-col>
            <el-col :span="1" v-if="editMode && canEditField( 'difficult_metering')">
                <el-checkbox v-model="difficult_metering" />
            </el-col>
            <el-col :span="1" v-else>
                <font-awesome-icon icon="check-square" class="orange" v-if="difficult_metering" />
                <font-awesome-icon :icon="['far', 'square']" class="orange" v-else />
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'volume') && isValueVisible(volume, 'volume')">
            <el-col :span="10">
                <span class="gray">
                    Объем
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'volume')">
                    <el-input size="mini" autocomplete="off" type="text" v-model="volume" />
                    <div class="field-error" v-if="errors.volume" v-text="errors.volume[0]"></div>
                </template>
                <template v-else>
                    {{ volume }}
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'finish') && isValueVisible(finish, 'finish')">
            <el-col :span="10">
                <span class="gray">
                    Отделка
                </span>
            </el-col>
            <el-col :span="1" v-if="editMode && canEditField( 'finish')">
                <el-checkbox v-model="finish" />
            </el-col>
            <el-col :span="1" v-else>
                <font-awesome-icon icon="check-square" class="orange" v-if="finish" />
                <font-awesome-icon :icon="['far', 'square']" class="orange" v-else />
            </el-col>
            <el-col :span="13" v-if="finish && canViewField('finish_amount')">
                <template v-if="editMode && canEditField('finish_amount')">
                    <auto-numeric
                        v-model="finish_amount"
                        :options="numericOptions"
                        class="autonumeric"
                    />
                    <div class="field-error" v-if="errors.finish_amount" v-text="errors.finish_amount[0]"></div>
                </template>
                <template v-else-if="isValueVisible(finish_amount)">
                    {{ finish_amount | formatFinance }}
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'jalousie') && isValueVisible(jalousie, 'jalousie')">
            <el-col :span="10">
                <span class="gray">
                    Жалюзи
                </span>
            </el-col>
            <el-col :span="1" v-if="editMode && canEditField( 'jalousie')">
                <el-checkbox v-model="jalousie" />
            </el-col>
            <el-col :span="1" v-else>
                <font-awesome-icon icon="check-square" class="orange" v-if="jalousie" />
                <font-awesome-icon :icon="['far', 'square']" class="orange" v-else />
            </el-col>
            <el-col :span="13" v-if="jalousie && canViewField('jalousie_amount')">
                <template v-if="editMode && canEditField('jalousie_amount')">
                    <auto-numeric
                        v-model="jalousie_amount"
                        :options="numericOptions"
                        class="autonumeric"
                    />
                    <div class="field-error" v-if="errors.jalousie_amount" v-text="errors.jalousie_amount[0]"></div>
                </template>
                <template v-else-if="isValueVisible(jalousie_amount)">
                    {{ jalousie_amount | formatFinance }}
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'place_photo') && isValueVisible(place_photo, 'place_photo')">
            <el-col :span="editMode ? 8: 10">
                <span class="gray">
                    Фото объекта
                </span>
            </el-col>
            <el-col :span="2" v-if="editMode && canEditField( 'place_photo')">
                <el-upload
                    action=""
                    :auto-upload="false"
                    :on-change="handleChange"
                    :on-exceed="handleExceed"
                    :limit="10"
                    :file-list="uploadFileList"
                    :show-file-list="false"
                    multiple
                    accept="image/*"
                >
                    <font-awesome-icon slot="trigger" icon="paperclip" class="orange pointer" />
                </el-upload>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 'place_photo')">
                    <el-tag
                        v-for="file in uploadFileList"
                        :key="file.name"
                        closable
                        :type="''"
                        @close="handleClose(file)"
                        @click.native="handleTagClick(file)"
                        class="pointer"
                        size="mini"
                        :disable-transitions="true"
                    >
                        {{ cutString(file.name) }}
                    </el-tag>
                    <div class="field-error" v-if="errors.place_photo" v-text="errors.place_photo[0]"></div>
                </template>
                <template v-else>
                    <el-tag
                        v-for="file in place_photo"
                        :key="file.id"
                        :type="''"
                        size="mini"
                        class="pointer"
                        @click.native="handleTagClick(file)"
                        :disable-transitions="true"
                    >
                        {{ cutString(file.name) }}
                    </el-tag>
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'refuse_before_metering') && isValueVisible(refuse_before_metering, 'refuse_before_metering')">
            <el-col :span="10">
                <span class="gray">
                    ОДЗ
                </span>
            </el-col>
            <el-col :span="1" v-if="editMode && canEditField( 'refuse_before_metering')">
                <el-checkbox v-model="refuse_before_metering" />
            </el-col>
            <el-col :span="1" v-else>
                <font-awesome-icon icon="check-square" class="orange" v-if="refuse_before_metering" />
                <font-awesome-icon :icon="['far', 'square']" class="orange" v-else />
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 'tech_refusal') && isValueVisible(tech_refusal, 'tech_refusal')">
            <el-col :span="10">
                <span class="gray">
                    Тех отказ
                </span>
            </el-col>
            <el-col :span="1" v-if="editMode && canEditField( 'tech_refusal')">
                <el-checkbox v-model="tech_refusal" />
            </el-col>
            <el-col :span="1" v-else>
                <font-awesome-icon icon="check-square" class="orange" v-if="tech_refusal" />
                <font-awesome-icon :icon="['far', 'square']" class="orange" v-else />
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 're_measurement') && isValueVisible(re_measurement, 're_measurement')">
            <el-col :span="10">
                <span class="gray">
                    Перезамер
                </span>
            </el-col>
            <el-col :span="1" v-if="editMode && canEditField( 're_measurement')">
                <el-checkbox v-model="re_measurement" />
            </el-col>
            <el-col :span="1" v-else>
                <font-awesome-icon icon="check-square" class="orange" v-if="re_measurement" />
                <font-awesome-icon :icon="['far', 'square']" class="orange" v-else />
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 're_measurement_date') && isValueVisible(re_measurement_date, 're_measurement_date') && re_measurement">
            <el-col :span="10">
                <span class="gray">
                    Дата перезамера
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 're_measurement_date')">
                    <el-date-picker
                        v-model="re_measurement_date"
                        type="date"
                        placeholder="дд.мм.гггг"
                        clearable
                        format="dd.MM.yyyy"
                        value-format="dd.MM.yyyy"
                        :picker-options="pickerOptions"
                        size="mini"
                        class="w100"
                    />
                    <div class="field-error" v-if="errors.re_measurement_date" v-text="errors.re_measurement_date[0]"></div>
                </template>
                <template v-else>
                    {{ re_measurement_date }}
                </template>
            </el-col>
        </el-row>
        <el-row v-if="canViewField( 're_measurement_time') && isValueVisible(re_measurement_time, 're_measurement_time') && re_measurement">
            <el-col :span="10">
                <span class="gray">
                    Время перезамера
                </span>
            </el-col>
            <el-col :span="14">
                <template v-if="editMode && canEditField( 're_measurement_time')">
                    <el-select
                        v-model="re_measurement_time"
                        placement="bottom"
                        popper-class="popper-dropdown"
                        autocomplete
                        clearable
                        placeholder=""
                        size="mini"
                    >
                        <el-option v-for="item in measurementTimeList" :key="item" :label="item" :value="item" />
                    </el-select>
                    <div class="field-error" v-if="errors.re_measurement_time" v-text="errors.re_measurement_time[0]"></div>
                </template>
                <template v-else>
                    {{ re_measurement_time }}
                </template>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { cardMixin } from '@/mixins/card';
import FileSaver from 'file-saver';
import { pickerOptions } from '@/common/pickerOptions';
import localReferences from '@/helpers/localReferences';

export default {
    name: 'Measurement',
    mixins: [
        cardMixin
    ],
    data() {
        return {
            uploadFileList: [],
            pickerOptions,
            measurerList: [],
            unpreparedMeasurerList: [],
            isMeasurerListLoading: false
        };
    },
    computed: {
        measurerUserName() {
            return this.$store.state.deals.current.measurer_user ? this.$store.state.deals.current.measurer_user.full_name : '';
        },
        measurementTimeList() {
            return this.$store.state.references.measurementTimes;
        },
        actualMeasurementDate() {
            return this.$store.state.deals.current.actual_measurement_date;
        },
        actualMeasurementTime() {
            return this.$store.state.deals.current.actual_measurement_time;
        },
        measurement_date: {
            get() {
                return this.$store.state.deals.current.measurement_date;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'measurement_date', value });
            }
        },
        measurement_time: {
            get() {
                return this.$store.state.deals.current.measurement_time;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'measurement_time', value });
            }
        },
        measurer_user_id: {
            get() {
                return this.$store.state.deals.current.measurer_user_id;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'measurer_user_id', value });
            }
        },
        difficult_metering: {
            get() {
                return this.$store.state.deals.current.difficult_metering;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'difficult_metering', value });
            }
        },
        volume: {
            get() {
                return this.$store.state.deals.current.volume;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'volume', value });
            }
        },
        finish: {
            get() {
                return this.$store.state.deals.current.finish;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'finish', value });
            }
        },
        jalousie: {
            get() {
                return this.$store.state.deals.current.jalousie;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'jalousie', value });
            }
        },
        place_photo: {
            get() {
                return this.$store.state.deals.current.place_photo;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'place_photo', value });
            }
        },
        refuse_before_metering: {
            get() {
                return this.$store.state.deals.current.refuse_before_metering;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'refuse_before_metering', value });
            }
        },
        tech_refusal: {
            get() {
                return this.$store.state.deals.current.tech_refusal;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'tech_refusal', value });
            }
        },
        re_measurement: {
            get() {
                return this.$store.state.deals.current.re_measurement;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 're_measurement', value });
            }
        },
        re_measurement_date: {
            get() {
                return this.$store.state.deals.current.re_measurement_date;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 're_measurement_date', value });
            }
        },
        re_measurement_time: {
            get() {
                return this.$store.state.deals.current.re_measurement_time;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 're_measurement_time', value });
            }
        },
        finish_amount: {
            get() {
                return this.$store.state.deals.current.finish_amount;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'finish_amount', value });
            }
        },
        jalousie_amount: {
            get() {
                return this.$store.state.deals.current.jalousie_amount;
            },
            set(value) {
                this.$store.commit('deals/setCurrentField', { field: 'jalousie_amount', value });
            }
        },
        isCurrentEmployerManager() {
            return this.$store.getters.isCurrentEmployerManager;
        }
    },
    methods: {
        goCard(id) {
            this.$router.push({ name: 'employer-card', params: { id } });
        },
        handleChange(file, fileList) {
            this.uploadFileList = fileList;
            this.$store.commit('deals/setCurrentField', { field: 'place_photo', value: [...this.uploadFileList] });
        },
        handleExceed() {
            this.$message({
                showClose: true,
                message: 'Внимание, лимит 10 файлов!',
                type: 'warning',
                duration: 5000,
                customClass: this.alertClass()
            });
        },
        handleClose(tag) {
            this.uploadFileList.splice(this.uploadFileList.indexOf(tag), 1);
            this.$store.commit('deals/setCurrentField', { field: 'place_photo', value: [...this.uploadFileList] });
        },
        handleTagClick(tag) {
            if (!tag.id) {
                return;
            }
            this.$store.dispatch('deals/getPhoto', { block: 'place', id: tag.id })
                .then(response => {
                    FileSaver(new Blob([response.data], { type: tag.type }), tag.name);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        updateMeasurerList(date) {
            if (!date || !date.length) {
                return;
            }
            this.isMeasurerListLoading = true;
            this.$store.dispatch('deals/getMeasurersList', date)
                .then(response => {
                    this.unpreparedMeasurerList = response;
                    if (this.canViewDateFired) {
                        this.measurerList = this.filterFiredEmployers(this.prepareMeasurerListByDeal(this.unpreparedMeasurerList, this.$store.state.deals.current));
                    } else {
                        this.measurerList = this.prepareMeasurerListByDeal(this.unpreparedMeasurerList, this.$store.state.deals.current);
                    }
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.isMeasurerListLoading = false;
                });
        },
        prepareMeasurerListByDeal(measurerList, deal) {
            return measurerList.map(measurer => {
                const availability = this.checkMeasurerAvailability(measurer, deal);
                return {
                    ...measurer,
                    disabled: availability.disabled,
                    disabledComment: availability.disabledComment
                };
            });
        },
        checkMeasurerAvailability(measurer, deal) {
            if (measurer.timesheets && measurer.timesheets.length && deal.actual_measurement_date) {
                const timesheet = measurer.timesheets.find(timesheet => timesheet.day === deal.actual_measurement_date.split('.').reverse().join('-'));
                if (timesheet && timesheet.status_id !== localReferences.timesheet.statuses.working) {
                    return { disabled: true, disabledComment: `${timesheet.status.name}` };
                }
            }
            if (measurer.reservations && measurer.reservations.length && deal.actual_measurement_time) {
                const reservation = measurer.reservations.find(reservation => reservation.day === deal.actual_measurement_date &&
                    reservation.time === deal.actual_measurement_time);
                if (reservation && reservation.is_reserved) {
                    return { disabled: true, disabledComment: 'бронь' };
                }
            }
            if (measurer.measurer_deals && measurer.measurer_deals.length && deal.actual_measurement_time) {
                const dealsAtSameDay = measurer.measurer_deals.filter(measurerDeal => measurerDeal.actual_measurement_date === deal.actual_measurement_date &&
                    measurerDeal.id !== deal.id);
                if (dealsAtSameDay && dealsAtSameDay.length) {
                    let conflictedDeal = dealsAtSameDay.find(measurerDeal => measurerDeal.actual_measurement_time === deal.actual_measurement_time);
                    if (conflictedDeal) {
                        return { disabled: true, disabledComment: `замер ${conflictedDeal.id}` };
                    }
                    const prevTime = localReferences.getPrevTime(deal.actual_measurement_time);
                    conflictedDeal = dealsAtSameDay.find(measurerDeal => measurerDeal.difficult_metering && measurerDeal.actual_measurement_time === prevTime);
                    if (prevTime && conflictedDeal) {
                        return { disabled: true, disabledComment: `замер ${conflictedDeal.id}` };
                    }
                    if (deal.difficult_metering) {
                        const nextTime = localReferences.getNextTime(deal.actual_measurement_time);
                        conflictedDeal = dealsAtSameDay.find(measurerDeal => measurerDeal.actual_measurement_time === nextTime);
                        if (nextTime && conflictedDeal) {
                            return { disabled: true, disabledComment: `замер ${conflictedDeal.id}` };
                        }
                    }
                }
            }
            if (deal.actual_measurement_time === null) {
                return { disabled: true, disabledComment: 'в сделке нет времени замера' };
            }
            return { disabled: false, disabledComment: '' };
        },
        showMeasurerSelectSpinner() {
            //Покажем спиннер, чтобы пользователь заметил изменение списка замерщиков
            setTimeout(() => { this.isMeasurerListLoading = false; }, 400);
        }
    },
    watch: {
        place_photo: {
            handler(value) {
                if (this.uploadFileList && value.length) {
                    this.uploadFileList = [...value];
                }
            },
            deep: true
        },
        actualMeasurementDate(date) {
            this.updateMeasurerList(date);
        },
        actualMeasurementTime() {
            this.isMeasurerListLoading = true;
            this.measurerList = this.prepareMeasurerListByDeal(this.unpreparedMeasurerList, this.$store.state.deals.current);
            this.showMeasurerSelectSpinner();
        },
        difficult_metering() {
            this.isMeasurerListLoading = true;
            this.measurerList = this.prepareMeasurerListByDeal(this.unpreparedMeasurerList, this.$store.state.deals.current);
            this.showMeasurerSelectSpinner();
        }
    },
    mounted() {
        if (this.uploadFileList && this.uploadFileList.length === 0 && this.place_photo.length) {
            this.uploadFileList = [...this.place_photo];
        }
        this.updateMeasurerList(this.actualMeasurementDate);
    }
};
</script>
